import { Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

// CONFIGS
import { DialogConfig } from '../../../shared/configs/dialog.config';

// COMPONENTS
import { trackById } from '../../../shared/util/track-by.util';
import { UiConfirmationDialogComponent } from '../../../ui/components/ui-confirmation-dialog/ui-confirmation-dialog.component';

// INTERFACES
import { IAutomationRule } from '../../interfaces';

// UTILS
@Component({
  selector: 'lum-automation-rule-table',
  templateUrl: './automation-rule-table.component.html',
  styleUrls: ['./automation-rule-table.component.scss'],
})
export class AutomationRuleTableComponent implements OnDestroy {
  @Input()
  rules :IAutomationRule[] = [];

  @Input()
  loading :boolean = false;

  @Output()
  deleteRuleEvent = new EventEmitter<number>();

  @Output()
  updateRuleEvent = new EventEmitter<IAutomationRule>();

  conditionKeyValue :{ [key :string] :string } = {
    boolean: 'Boolean',
    date: 'Date',
    item_count: 'Item Count',
    text: 'Text',
    aggregate_relationship: 'Aggregate Relationship',
    has_not_performed_action: 'Has Not Performed Action',
    has_tag: 'Has Tag',
    order_age: 'Order Age',
    order_status: 'Order Status',
    shipping_method: 'Shipping Method',
    product_sku: 'Product Sku',
    order_total: 'Order Total',
    order_weight: 'Order Weight',
    approval_status: 'Approval Status',
    bom_item_received: 'BOM Item Received',
    bom_stock_availability: 'BOM Stock Availability',
  };

  actionKeyValue :{ [key :string] :string } = {
    assign_tag: 'Assign Tag',
    update_column: 'Update Column',
    aggregate_relationship: 'Aggregate Relationship',
    email_notification: 'Email',
    hold_order: 'Hold Order',
    send_edi_855: 'Send EDI 855',
    send_unallocated_orders_in_purgatory_email:
      'Send UnAllocated Orders in Purgatory Email',
    send_inbound_shipment_email: 'Send Inbound Shipment Email',
    complete_assembly_order: 'Complete Assembly Order',
  };

  eventKeyValue :{ [key :string] :string } = {
    invoice_updated: 'Invoice Updated',
    invoice_created: 'Invoice Created',
    order_updated: 'Order Updated',
    order_created: 'Order Created',
    order_item_created: 'Order Item Created',
    model_updated: 'Model Updated',
    daily: 'Daily',
    hourly: 'Hourly',
    receiving: 'Receiving',
  };

  trackById = trackById;
  private onDestroy$ = new Subject();

  constructor(private dialog :MatDialog) {}

  ngOnDestroy() :void {
    this.onDestroy$.next(null);
    this.onDestroy$.complete();
  }

  onDeleteRule(id :number) :void {
    this.dialog
      .open(UiConfirmationDialogComponent, {
        data: {
          title: 'Confirm Action',
          message: 'Are you sure you want to delete this rule?',
        },
        width: DialogConfig.sizes.small,
      })
      .afterClosed()
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((confirm :boolean) => {
        if (confirm) {
          this.deleteRuleEvent.emit(id);
        }
      });
  }
}
